import type { Company } from '@pn/core/domain/intel/company';
import type { CompanyKPI } from '@pn/core/domain/intel/intel';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { companyKPIsSlice } from './companyKPIsSlice';

export const useCompanyKPIsStorage = () => {
  const { name, getInitialState } = companyKPIsSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    kpis: useSliceSelector((state) => state.kpis),
    loadedCompanyIds: useSliceSelector((state) => state.loadedCompanyIds),
  };
};

export const companyKPIsActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = companyKPIsSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    receive: (kpis: CompanyKPI[]) => dispatch(actions.receive(kpis)),
    request: () => dispatch(actions.request()),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
    load: (companyIds: Company['id'][]) => dispatch(actions.load(companyIds)),
  };
};
